import { PsFileUploadPlaceholder } from '../handlers';
import { FileItem } from '../types';

export const PS_FILE_UPLOAD_MAX_FILE_SIZE = 20971520;
export const PS_FILE_UPLOAD_MAX_TOTAL_FILE_SIZE = 26214400;

export function createPsFileUploadPlaceholder(
  file: FileItem,
  loadInitFile: (file: FileItem) => Promise<Blob>
): PsFileUploadPlaceholder {
  let content: Promise<Blob> | undefined;
  return {
    name: file.name,
    // 0 means "not provided" for FileItems built without a size.
    size: file.size > 0 ? file.size : undefined,
    type: file.contentType,
    load: () => {
      if (!content) {
        content = loadInitFile(file).catch((error) => {
          content = undefined;
          throw error;
        });
      }
      return content;
    }
  };
}

export function isPsFileUploadPlaceholder(
  file: unknown
): file is PsFileUploadPlaceholder {
  return (
    !!file &&
    typeof (file as PsFileUploadPlaceholder).load === 'function' &&
    !(file instanceof Blob)
  );
}
